import "./Header.css";

function Header() {
  return <header id="header">Sudden Music</header>;
}

export default Header;
